import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric, TextArea } from 'ypf-pas-general-ui-components';

import { getActionComponents } from '../../../services/workReport';
import {
  getPerfilEjecuta,
  rectifyLocationProgramPointAdapter
} from '../../../services/programPointsService';
import { assignmentTypeEnum, workReportLineStatus } from '../../../utils/dataStatus';
import { capitalize, formatDateToSpanish, validateDecimalInput } from '../../../utils/formatUtils';
import { getActionComponentsMonthly } from '../../../services/monthlyServiceRequest';
import { getErrorMessage } from '../../../services/certificationsMaster';
import { Line } from '../../../utils/globalPropTypes';
import EditAmount from '../../InspectExpertReview/EditAmount';
import ErrorComments from '../../InspectExpertReview/ErrorComments';
import LoaderContext from '../../../context/LoaderProvider';
import ProgramPointList from '../ProgramPointModal/ProgramPointList/ProgramPointList';
import useToast from '../../../hooks/useToast';
import useLocationProgramPoints, {
  defaultInitialValues
} from '../ProgramPointModal/useLocationProgramPoints';
import './InspectorExpertReviewModal.scss';
import '../WorkReportModals.scss';
import { inspector } from '../../../security/constantsRols';
import { checkRol } from '../../../security';

const InspectorExpertReviewModal = (props) => {
  const {
    show,
    onHide,
    onAccept,
    positionName,
    lineName,
    um,
    date,
    quantity,
    // Line actualmente es un number, deberia ser un tipo Line
    line,
    asignationType,
    setNewFetch
  } = props;

  const { day, month, year } = formatDateToSpanish(date);
  const [disableButton, setDisableButton] = useState(false);
  const [disabledInputQuantity, setDisabledInputQuantity] = useState(true);
  const [errorMessages, setErrorMessages] = useState([]);
  const { setLoader } = useContext(LoaderContext);
  const [unitMeasure, setUnitMeasure] = useState();
  const [colors, setColors] = useState();
  const [responseText, setResponseText] = useState({
    active: false,
    message: ''
  });
  const [enableEdit, setEnableEdit] = useState(false);

  const { setNewToast } = useToast();

  const {
    values,
    getProgramPointsData,
    calculateTotalValue,
    setFieldTouched,
    loading,
    resetForm,
    setFieldValue,
    errors,
    touched
  } = useLocationProgramPoints({
    line,
    isRectify: true,
    initialValues: {
      ...defaultInitialValues,
      comment: '',
      quantityForm: quantity,
      expertReview: false,
      action: '',
      locationsCopy: []
    }
  });

  const handleOnChangeQuantity = async (evt) => {
    if (typeof evt === 'number') {
      setFieldValue('quantityForm', evt);
    } else if (validateDecimalInput(evt.target.value, 3)) {
      setFieldValue('quantityForm', evt.target.value);
    }
    setFieldTouched('quantityForm');
    if (typeof evt !== 'number') {
      setFieldTouched('comment');
    }
  };

  const handleOnchangeExpertReview = async (value = undefined) => {
    setFieldValue('expertReview', typeof value === 'boolean' ? value : !values.expertReview);
    setFieldTouched('expertReview');
  };

  const handleChangeOnColors = (paramColors) => {
    setColors(paramColors);
  };

  const clearForm = async () => {
    setEnableEdit(false);
    resetForm();
    setDisableButton(false);
    setDisabledInputQuantity(true);
    setResponseText({
      active: false,
      message: ''
    });
    setErrorMessages([]);
    setNewFetch((oldValue) => !oldValue);
    onHide();
  };

  const errorMessage = async (lineParam) => {
    try {
      setLoader(true);
      const errorMessagesNew = await getErrorMessage(lineParam?.idParteDiario || lineParam?.id);

      setErrorMessages(errorMessagesNew);
      setLoader(false);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setLoader(false);
    }
  };

  const fetchProgramPoints = async () => {
    try {
      setLoader(true);
      const perfilEjecuta = getPerfilEjecuta();

      await getProgramPointsData(perfilEjecuta, true);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoader(false);
    }
  };

  const getDataMonthly = async () => {
    try {
      setLoader(true);
      const response = await getActionComponentsMonthly(line?.idParteDiario || line?.id);

      if (line?.tienePuntosPrograma) {
        fetchProgramPoints();
      }
      handleOnChangeQuantity(response?.cantidad);
      handleOnchangeExpertReview(response?.revisionExperta);
      setUnitMeasure(response?.unidadMedida);
      handleChangeOnColors(response?.colores);
      setLoader(false);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setLoader(false);
    }
  };

  const getDataForAmount = async () => {
    try {
      setLoader(true);
      const response = await getActionComponents(line?.idParteDiario || line?.id);

      if (line?.tienePuntosPrograma) {
        fetchProgramPoints();
      }

      handleOnChangeQuantity(response?.cantidad);
      handleOnchangeExpertReview(response?.revisionExperta);
      setUnitMeasure(response?.unidadMedida);
      handleChangeOnColors(response?.colores);
      setLoader(false);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setLoader(false);
    }
  };

  const handleClickRectifyButton = () => {
    setDisabledInputQuantity((oldState) => {
      if (!oldState) {
        setFieldValue('locations', values.locationsCopy);
      }

      return !oldState;
    });
  };

  useEffect(() => {
    if (!line?.tienePuntosPrograma) {
      if (enableEdit && +values.quantityForm > 0 && +values.quantityForm !== quantity) {
        setDisableButton(true);
      } else if (!!Object.values(errors).length || !Object.values(touched).length) {
        setDisableButton(true);
      } else {
        setDisableButton(false);
      }
    } else if (
      (values?.locations?.every((location) =>
        location.programPoints?.every((programPoint) => programPoint.quantity > 0)
      ) &&
        values?.locations?.some((location, indexLocation) =>
          location.programPoints?.some(
            (programPoint, indexPP) =>
              Number(programPoint.quantity) !==
              Number(values?.locationsCopy[indexLocation]?.programPoints[indexPP]?.quantity)
          )
        )) ||
      (values?.locations?.every((location) =>
        location.programPoints?.every((item) => item.points > 0)
      ) &&
        values?.locations?.some((location, indexLocation) =>
          location.programPoints?.some(
            (programPoint, indexPP) =>
              Number(programPoint.points) !==
              Number(values?.locationsCopy[indexLocation]?.programPoints[indexPP]?.points)
          )
        ))
    ) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [
    errors,
    touched,
    values.quantityForm,
    values?.locations,
    values.comment,
    enableEdit,
    line?.tienePuntosPrograma,
    values?.locationsCopy,
    quantity
  ]);

  useEffect(() => {
    if (line && show) {
      errorMessage(line);
      if (asignationType === assignmentTypeEnum.Mensualizada) {
        getDataMonthly();
      } else {
        getDataForAmount();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [line, show]);

  const hasTotalValuesChange = JSON.stringify(
    (values?.locations || []).map((location) => location.totalValue)
  );

  useEffect(() => {
    if (!values?.locations) return;

    const { locationTotalValue, locationTotalValueFijado } = calculateTotalValue(values.locations);

    setFieldValue('locationTotalValue', locationTotalValue);
    setFieldValue('locationTotalValueFijado', locationTotalValueFijado);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasTotalValuesChange]);

  const disableInspectorZeroQuantity =
    line.cantidad === 0 && line?.estadoEnum === workReportLineStatus.fijar && checkRol(inspector);

  const invalidQuantity =
    line?.tienePuntosPrograma &&
    (values?.locations || [])
      .filter((loc) => loc?.habilitaVentana)
      .flatMap((location) => location?.programPoints || [])
      .find((qntyObj) => !qntyObj?.quantity);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={clearForm}
      primaryAction={async () => {
        try {
          setLoader(true);

          let cantidadToSend = Number(values?.quantityForm || 0);
          let locations = [];

          if (line?.tienePuntosPrograma) {
            locations = values?.locations;
            cantidadToSend = calculateTotalValue(locations)?.locationTotalValue;
          }
          const perfilEjecuta = getPerfilEjecuta();

          const response = await rectifyLocationProgramPointAdapter(
            {
              ...line,
              idParteDiario: line?.idParteDiario || line?.id,
              unidadMedicion: unitMeasure,
              comentarios: values?.comment,
              revisionExperta: values?.expertReview ?? null,
              requiereConformidad: line?.requiereConformidad ?? null,
              requiereAdjuntar: line?.requiereAdjuntar ?? null
            },
            cantidadToSend,
            locations,
            perfilEjecuta
          );

          onHide();
          setNewToast({
            type: 'SUCCESS',
            message: response?.mensaje || response
          });

          onAccept();
        } catch (err) {
          setNewToast({
            type: 'ERROR',
            message: err?.message
          });
        } finally {
          setLoader(false);
          setDisabledInputQuantity(true);
        }
      }}
      primaryActionDisabled={!disableButton || invalidQuantity || !values?.comment.length}
      primaryActionLabel="Informar revisión"
      secondaryAction={clearForm}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title="Requiere revisión experta"
    >
      <>
        <div className="text-center modal-info">
          <div className="d-flex justify-content-center flex-wrap">
            <span>&quot;{positionName}</span>
            <span>{lineName}</span>
            <span>
              {um} {quantity?.toLocaleString('es-AR')}&quot;
            </span>
          </div>
          Para el día {capitalize(day?.text)}, {day?.number} de {month} de {year}
        </div>
        {!responseText.active && line ? (
          <>
            {errorMessages.length > 0 && (
              <>
                <hr className="my-4" />
                <div className="w-100">
                  <ul className="container_error_comments">
                    <ErrorComments
                      disableButton={disableButton}
                      errorMessages={errorMessages}
                      setErrorMessages={setErrorMessages}
                      setFieldValue={setFieldValue}
                      setResponseText={setResponseText}
                      value={values?.action}
                    />
                  </ul>
                </div>
              </>
            )}

            <div className="w-100 ">
              <div className="my-4 infinte-scroll">
                {line?.tienePuntosPrograma ? (
                  <ProgramPointList
                    disabledInputPP={disabledInputQuantity}
                    disabledInputQuantity={disabledInputQuantity}
                    handleClickRectifyButton={handleClickRectifyButton}
                    idParteDiario={line?.idParteDiario}
                    isLocation
                    line={line}
                    loading={loading}
                    onChangeExpertReview={handleOnchangeExpertReview}
                    setFieldValue={setFieldValue}
                    // showAlert={showAlert}
                    showExpertReview
                    showRectifyQuantityButton
                    values={values}
                    viewCSA
                    viewInputs
                  />
                ) : (
                  <EditAmount
                    colors={colors}
                    disableInspectorZeroQuantity={disableInspectorZeroQuantity}
                    enableEdit={enableEdit}
                    handleChangeOnColors={handleChangeOnColors}
                    handleOnChangeQuantity={handleOnChangeQuantity}
                    line={line}
                    onChange={handleOnChangeQuantity}
                    onChangeExpertReview={handleOnchangeExpertReview}
                    setEnableEdit={setEnableEdit}
                    unitMeasure={unitMeasure}
                    value={values?.quantityForm}
                    valueExpertReview={values?.expertReview}
                  />
                )}
              </div>
            </div>

            <div className="my-4">
              <div className="comment-input-container">
                <TextArea
                  disabled={disableInspectorZeroQuantity}
                  errors={errors?.comment}
                  isInvalid={!!errors?.comment}
                  label="Comentario"
                  maxLength={512}
                  name="comment"
                  onChange={async (e) => {
                    setFieldValue('comment', e.target.value);
                    setFieldTouched('comment');
                  }}
                  placeholder="Motivo de edición"
                  resize={false}
                  value={values?.comment}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="text-center modal-info">
            <hr className="divide-line-bottom" />
            <p className="d-flex justify-content-center flex-wrap m-4">{responseText.message}</p>
          </div>
        )}
      </>
    </ModalGeneric>
  );
};

export default InspectorExpertReviewModal;

InspectorExpertReviewModal.propTypes = {
  assignmentTypeEnum: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  date: PropTypes.string,
  line: PropTypes.oneOfType([PropTypes.number, Line]),
  lineName: PropTypes.string,
  onAccept: PropTypes.func,
  onHide: PropTypes.func,
  positionName: PropTypes.string,
  quantity: PropTypes.number,
  show: PropTypes.bool,
  um: PropTypes.string,
  asignationType: PropTypes.number.isRequired,
  setNewFetch: PropTypes.func
};

InspectorExpertReviewModal.defaultProps = {
  assignmentTypeEnum: {
    id: 0,
    nombre: ''
  },
  line: null,
  show: false,
  quantity: null,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  },
  date: '',
  lineName: '',
  positionName: '',
  um: '',
  setNewFetch: () => {
    /* Empty */
  }
};
